<template>
  <RevContainer
    id="toast-wrapper"
    class="pb-32 md:pb-36"
    data-test="refer-a-friend-page"
  >
    <div class="flex flex-col gap-40">
      <RevSkeleton
        v-if="!hasFetchedOnce"
        height="330px"
        shape="rectangle"
        width="100%"
      />
      <template v-else-if="data?.hasPromoCode">
        <MaxReferralsReachedBanner
          v-if="data.myReferrals.referralLimitReached"
        />
        <WithReferralView
          v-if="data.referralCode"
          v-bind="data"
          @promo-code-generated="refresh"
        />
      </template>
      <NoReferralCodeBlock v-else />
    </div>

    <RevDivider class="mb-40 mt-56 grow" />

    <RevSkeleton
      v-if="!hasFetchedOnce"
      height="200px"
      shape="rectangle"
      width="100%"
    />
    <HowDoReferralsWorkBlock v-else />
  </RevContainer>
</template>

<script lang="ts" setup>
import { createError } from '#imports'
import { watch } from 'vue'

import { RevContainer } from '@ds/components/Container'
import { RevDivider } from '@ds/components/Divider'
import { RevSkeleton } from '@ds/components/Skeleton'

import HowDoReferralsWorkBlock from './components/HowDoReferralsWorkBlock.vue'
import MaxReferralsReachedBanner from './components/MaxReferralsReachedBanner.vue'
import NoReferralCodeBlock from './components/NoReferralCodeBlock.vue'
import WithReferralView from './components/WithReferralView.vue'
import { useReferAFriend } from './useReferAFriend'

const { data, error, refresh, hasFetchedOnce } = useReferAFriend()

watch(error, () => {
  if (error.value) {
    throw createError({
      ...error.value,
      fatal: true,
    })
  }
})
</script>
